import { render, staticRenderFns } from "./ShareProfileButton.vue?vue&type=template&id=cbca37bc"
import script from "./ShareProfileButton.vue?vue&type=script&lang=js"
export * from "./ShareProfileButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports